<template>
  <div class="home" style="background-color: #F7F7F7;">
    <!-- 头部模块 -->
    <HeaderComponent :swipeImg="swipeImg"></HeaderComponent>
    <!-- 十个商品模块 -->
    <ProductComponent :productData="productData"></ProductComponent>
    <!-- 多个模块 -->
<!--    <CommodityZone :iPhoneAll="modelData[2]" :swipeData="modelData[3]" :model1="modelData[4]" :model2="modelData[5]"
      <!-- :model3="modelData[6]"></CommodityZone> -->
    <!-- <WaterNavBar></WaterNavBar> -->
    <!-- 热门推荐和电脑平板 -->
    <!-- <HomeWaterfall></HomeWaterfall> -->
	<!-- 金刚图模块 -->
	<jinGangTu :jinGangTuBg="jinGangTuBg" :jinGangTuSH="jinGangTuSH"/>
	<!-- 尾部模块 -->
	<Footer :FooterSh="FooterSh" :FooterMain="FooterMain"/>
	<div class="filing">
		<div>内蒙古江湾科技有限公司</div>
		<div>公司地址：内蒙古包头市昆都仑区钢铁大街33号万號国际-2606</div>
		<div>客服电话：13522315820</div>
		<div>版权所有ICP备案号：<a data-v-4258fb5f="" href="https://beian.miit.gov.cn/" target="_blank">蒙ICP备2026001275号-1</a></div>
	</div>
	<loading v-show="!swipeImg.length || !modelData.length || !productData.length"></loading>
  </div>
</template>
<script>
import {
	baseUrl
} from "@/common/domain"
import eventBus from "@/common/event-bus";
import ProductComponent from "@/components/Home/ProductComponent.vue";
// import CommodityZone from "@/components/Home/CommodityZone.vue";
import jinGangTu from "@/components/Home/jinGangTu.vue";
import HeaderComponent from "@/components/Home/HeaderComponent.vue";
import HomeWaterfall from "@/components/Home/HomeWaterfall.vue";
import WaterNavBar from "@/components/Home/WaterNavBar.vue";
import Footer from "@/components/Home/Footer.vue"
export default {
  name: 'HomeView',
  components: {
    ProductComponent,
    // CommodityZone,
	jinGangTu,
    HeaderComponent,
    HomeWaterfall,
    WaterNavBar,
	Footer
  },
  data() {
    return {
	  swipeImg:[],
      modelData: [],
	  productData:[],
	  jinGangTuBg:{
		  backgroundImg: '',
		  title: '',
		  subtitle: '',
		  jumpUrl: '',
	  },
	  jinGangTuSH:[],
	  FooterSh:[],
	  FooterMain:{
		  goods:'',
		  img:'',
		  jumpType:'',
		  jumpUrl:'',
		  title:''
	  }
    }
  },
  created() {
    this.getModelData();
    eventBus.$emit("correctPath", window.location.pathname);//NavigationBar.vue
	this.getuserid();
  },
  methods: {
	// todetil(item){
	// 	// console.log(item);
	// },
	getuserid(){
		const urlParams = new URLSearchParams(window.location.search);
		const saleuserid = urlParams.get('saleuserid');
		if(saleuserid == null) {
			localStorage.setItem('saleuserid', '0');
		}else{
			localStorage.setItem('saleuserid', saleuserid);
		}
		
	},
    getModelData() {
	const urlParams = new URLSearchParams(window.location.search);
	const saleuserid = urlParams.get('saleuserid');
      this.$sendGet("Index/index",{page:1,saleuserid:saleuserid})
        .then(res => {
          if (res.data.status === 200)
            this.modelData.push(...res.data.data.data);
			let homeAllData = res.data.data.data;
			let images= [];
			homeAllData.forEach(item=>{
				if(!item.params) return;
				let params = JSON.parse(item.params);
				try {
					if (item.type == 1) {
						params.forEach(item => {
							this.swipeImg.push({
								img: baseUrl + item.img
							})
						})
					}else if(item.type == 2){
						params.forEach(item => {
							this.productData.push({
								img: baseUrl + item.img
							})
						})
					}else if(item.type == 4){
							let paramsObj = typeof item.params === 'string' ? JSON.parse(item.params) : item.params;
							 if (paramsObj.goods && Array.isArray(paramsObj.goods)) {
							        paramsObj.goods.forEach(goodsItem => {
							            if (goodsItem.imgurl) {
							                goodsItem.imgurl = baseUrl + goodsItem.imgurl;
							            }
							        });
							    }
								this.jinGangTuBg.backgroundImg = baseUrl + paramsObj.main.backgroundImg;
								this.jinGangTuBg.jumpUrl = baseUrl + paramsObj.main.jumpUrl
								this.jinGangTuBg.subtitle = paramsObj.main.subtitle
								this.jinGangTuBg.title = paramsObj.main.title
								this.jinGangTuSH.push(paramsObj.goods)
						
					}else if(item.type == 9){
						let paramsObj = typeof item.params === 'string' ? JSON.parse(item.params) : item.params;
						paramsObj =  paramsObj[0];
						if (paramsObj.main) {
							
						    if (paramsObj.main.img) {
						      paramsObj.main.img = baseUrl + paramsObj.main.img;
							  paramsObj.main.imgurl = baseUrl + paramsObj.main.imgurl;
						    }
						  }
						  if (paramsObj.goods && Array.isArray(paramsObj.goods)) {
						      paramsObj.goods.forEach(goodsItem => {
						        if (goodsItem.imgurl) {
						          goodsItem.imgurl = baseUrl + goodsItem.imgurl;
						        }
						      });
						    }
							if (paramsObj.main) {
							    this.FooterMain = {
							      goods: paramsObj.main.goods, // 这是一个对象，不是URL
							      img: paramsObj.main.img,
							      jumpType: paramsObj.main.jumpType,
							      jumpUrl: paramsObj.main.jumpUrl,
							      title: paramsObj.main.title
							    };
							  }
							  if (paramsObj.goods && Array.isArray(paramsObj.goods)) {
							      this.FooterSh = paramsObj.goods;
							    }
						
							
						   
					}
				} catch (error) {
					console.error("解析params失败", error);
				}
			})
			
        })
    },
  }
}
</script>
<style lang="scss" scoped>
.filing {
	height: 103px;
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 12px;
	padding: 10px;
	margin-top: 10px;
}
</style>


